"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const round_1 = require("../../numbers/round");
/*
 * Return percent from a given fraction with desired number of decimals
 *
 * @Param {number} fraction = The fraction to transform
 * @Param {number} decimals = Number of decimals
 *
 * @Example
 *
 *   percent(0.1337, 2)
 *   //=> 13.37
 */
exports.percent = (fraction, decimals = 0) => round_1.round(fraction * 100, decimals);
//# sourceMappingURL=percent.js.map